/* eslint-disable */
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
// import Typography from "@material-ui/core/Typography";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import { OrderDetails_order_sendgridWebhook_edges_node } from "@saleor/orders/types/OrderDetails";
import React from "react";
// import CardTitle from "@saleor/components/CardTitle";
import { maybe, splitDateTime } from "../../../misc";
import { PageListProps } from "@saleor/types";
import { TableBody, TableFooter } from "@material-ui/core";
import TablePagination from "@saleor/components/TablePagination";

interface OrderWebhookProps extends PageListProps {
  webhookInfos: OrderDetails_order_sendgridWebhook_edges_node[];
}
const numberOfColumns = 9;
const OrderWebhook: React.FC<OrderWebhookProps> = ({
  webhookInfos,
  pageInfo,
  disabled,
  onNextPage,
  onPreviousPage
}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Card>
      <ResponsiveTable>
        {open && (
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={numberOfColumns}
                hasNextPage={
                  pageInfo && !disabled ? pageInfo.hasNextPage : false
                }
                onNextPage={onNextPage}
                hasPreviousPage={
                  pageInfo && !disabled ? pageInfo.hasPreviousPage : false
                }
                onPreviousPage={onPreviousPage}
              />
            </TableRow>
          </TableFooter>
        )}
        <TableBody>
          <TableRow>
            <TableCell colSpan={numberOfColumns}>
              {/* <FormattedMessage
                defaultMessage="Sendgrid"
                description="Sendgrid"
              />
              */}
              {/* <CardTitle title={"Sendgrid"} /> */}

              <span style={{ fontSize: "16px", lineHeight: "32px" }}>
                Sendgrid
              </span>
              {webhookInfos?.length > 0 && (
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                  style={{ float: "right" }}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              )}
            </TableCell>
          </TableRow>

          {open && (
            <TableRow>
              {/* <TableCell>
                {<IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpen(!open)}
                >
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                }
              </TableCell> */}
              <TableCell colSpan={9}>
                {/* <FormattedMessage
                  defaultMessage="email"
                  values={{
                    trackingNumber: (
                      <Typography color="textPrimary" variant="body2">
                        {webhookInfo?.email}
                        {console.log(webhookInfo?.email, "aaaaaaaaaaa")}
                      </Typography>
                    )
                  }}
                /> */}
                {/* <TableRow >
                  <TableCell colSpan={5}> */}
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box margin={1}>
                    {webhookInfos &&
                      webhookInfos.length > 0 &&
                      webhookInfos.map((info, i) => (
                        <TableRow key={i}>
                          <TableCell>{info?.email}</TableCell>
                          <TableCell>{info?.event}</TableCell>
                          <TableCell>
                            {info?.eventTimes
                              ? splitDateTime(maybe(() => info?.eventTimes, ""))
                                  .date +
                                " " +
                                splitDateTime(maybe(() => info?.eventTimes, ""))
                                  .time
                              : null}
                          </TableCell>
                        </TableRow>
                      ))}
                  </Box>
                </Collapse>
                {/* </TableCell>
                </TableRow> */}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </ResponsiveTable>
    </Card>
  );
};
export default OrderWebhook;
